<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <MovementTypeForm v-if="movementType" :movementType="movementType" />
      <LoadingPage v-if="!movementType"/>
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import MovementTypeForm from '@/components/settings/stock-registers/movementType/MovementTypeForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'MovementTypeEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    MovementTypeForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      movementType: state => state.movementtype.movementTypeById
    })
  },
  methods: {
    ...mapActions('movementtype', ['fetchById'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  }
}
</script>